// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border-container{width:100%;position:relative;border-radius:8px;border-width:var(--borderContainer-borderSize);border-style:solid;border-color:var(--borderContainer-borderColor)}.border-container--small{padding:var(--borderContainer-size-small)}.border-container--default{padding:var(--borderContainer-size-default)}.border-container--medium{padding:var(--borderContainer-size-medium)}.border-container--big{padding:var(--borderContainer-size-big)}", ""]);
// Exports
module.exports = exports;
